import { getEntityRef, getRootContainerProps } from "@client/content/lib/helper";
import FormStyleProvider from "@client/content/Providers/FormStyle/container";
import { type RootContainerProps } from "@client/content/types";
import appInfo from "@common/appInfo";
import { useAiChatValue, type UseAiChatValueArgs } from "@common/components/AiChat/hooks";
import { useI18n } from "@common/hooks/i18n";
import useStorage from "@common/hooks/storage";
import apiV1 from "@common/lib/api";
import * as React from "react";
import Chat from "./Chat";
import Chats from "./Chats";

import "./style.less";

export type MapProps = RootContainerProps & {
  agentId: string;
};
export default (props: MapProps) => {
  const i18n = useI18n();

  const [mode, setMode] = React.useState<"chat" | "allChats">("chat");

  const [storage, patchState] = useStorage<{ currentChatId: string | null }>({
    defaultValue: { currentChatId: null },
    key: `AI_MODULE_${props.id}`
  });

  const chatArgs = React.useMemo(
    (): UseAiChatValueArgs => ({
      api: {
        agents: {
          get: () => apiV1.get(i18n, `/api/site/v1/ai/agents/${props.agentId}`)
        },
        chats: {
          getAll: () =>
            appInfo.user ? apiV1.get(i18n, "/api/site/v1/ai/chats", { agentId: props.agentId }) : Promise.resolve([]),
          sendMessage: (id, data) => apiV1.post(i18n, `/api/site/v1/ai/chats/${id}/sendMessage`, data)
        },
        chatMessages: {
          getAll: (id) => apiV1.get(i18n, `/api/site/v1/ai/chats/${id}/messages`)
        }
      },
      currentChatId: storage.currentChatId
    }),
    [props.agentId, storage.currentChatId]
  );

  const chat = useAiChatValue(chatArgs);

  return (
    <FormStyleProvider {...getEntityRef(props)}>
      <div className="content">
        {mode === "allChats" ? (
          <Chats
            {...getRootContainerProps(props)}
            chats={chat.chats}
            onBackClick={() => setMode("chat")}
            onChatClick={(id) => {
              patchState({ currentChatId: id });
              setMode("chat");
            }}
          />
        ) : (
          <Chat
            {...getRootContainerProps(props)}
            chat={chat}
            onChatsClick={appInfo.user ? () => setMode("allChats") : undefined}
            onNewChatClick={storage.currentChatId ? () => patchState({ currentChatId: null }) : undefined}
            onSendMessage={async (message: string) => {
              const chatId = await chat.sendMessage(message);
              patchState({ currentChatId: chatId });
            }}
          />
        )}
      </div>
    </FormStyleProvider>
  );
};
